import { render, staticRenderFns } from "./LemmaSearch.vue?vue&type=template&id=48b05ae1&scoped=true&"
import script from "./LemmaSearch.vue?vue&type=script&lang=js&"
export * from "./LemmaSearch.vue?vue&type=script&lang=js&"
import style0 from "./LemmaSearch.vue?vue&type=style&index=0&id=48b05ae1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b05ae1",
  null
  
)

export default component.exports